import { paths as accountingPaths } from '../Accounting/paths';

export const paths = [...accountingPaths];
